import { motion } from 'motion/react';

interface HealthDataEditorTitleDesktopProps {
  className?: string;
}

export function HealthDataEditorTitleDesktop({
  className = '',
}: HealthDataEditorTitleDesktopProps) {
  return (
    <motion.div
      className={`flex flex-col gap-[24px] items-start justify-center w-full h-full ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {/* Title */}
      <div className="flex flex-col gap-[3px] items-start w-full">
        <motion.h1
          className="font-['Inter'] font-normal text-[44px] leading-[56px] tracking-[0.3px] text-white w-full"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Your Health Data
        </motion.h1>
      </div>

      {/* Divider */}
      <div className="flex flex-col h-px items-start w-full">
        <motion.div
          className="bg-[#d4c2b5] h-px w-full"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        />
      </div>

      {/* Description */}
      <motion.p
        className="font-['Inter'] font-normal text-[14px] leading-[1.4] text-white w-[664px] max-w-full"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        Keep your Health Data up to date so your risk scores and recommendations stay aligned with your life, habits, latest test results, and more.
      </motion.p>
    </motion.div>
  );
}
